<template>
  <router-link
    :to="route"
    :class="{ 'entity__item--share': isShare, 'entity__item--news': isNews }"
    class="entity__item no-hover"
  >
    <div class="entity__item-img">
      <div class="ratio-container">
        <ImgComponent :head_img="item.head_img" width="600" height="800" quality="90" />
      </div>
    </div>
    <div class="entity__item-info">
      <span v-if="item.date_end" class="entity__item-date">
        Акция действует до {{ item.date_end | humanDateMonth }}!
      </span>
      <div class="entity__item-bottom">
        <time
          class="entity__item-subtitle"
          v-if="item.published_at"
          :datetime="item.published_at | robotDate"
        >
          {{ item.published_at | formatDate }}
        </time>
        <h3 v-if="item.title" class="entity__item-title" :title="item.title">{{ item.title }}</h3>
        <span v-if="item.subtitle" class="entity__item-subtitle">{{ item.subtitle }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "EntityCardComponent",
  props: {
    item: Object,
    isShare: Boolean,
    isNews: Boolean,
  },
  computed: {
    route() {
      if (this.isShare) {
        return { name: "catalog", query: { share_id: this.item.id } };
      }
      return { name: "news_item", params: { id: this.item.id } };
    },
  },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/ratio.styl"
@import "~@/styles/mixins/maxlines.styl"
.entity {
  &__item {
    position relative
    display flex
    color var(--white)
    border-radius: var(--main_radius);
    overflow hidden
    width calc(33.3333% - 20px)
    max-height 478px
    +below(990px) {
      width calc(50% - 15px)
    }
    +below(560px) {
      width 100%
    }

    &:hover {
      opacity 0.9
    }

    &:after {
      content ""
      display block
      absolute left right top bottom
      background: linear-gradient(9.61deg, var(--black) 0%, rgba(0, 0, 0, 0) 51.98%);
      opacity 0.5
    }

    &--share {
      &:first-child {
        width calc(66.6666% - 15px)
        +below(990px) {
          width calc(50% - 15px)
        }
        +below(560px) {
          width 100%
        }

        .entity__item-img {
          ratio(857, 478)
          height 100%
          +below(990px) {
            ratio(413, 478)
          }
        }
      }

      &:nth-child(2) {
        width calc(33.3333% - 15px)
        +below(990px) {
          width calc(50% - 15px)
        }
        +below(560px) {
          width 100%
        }
      }
    }

    &--news {
      & ^[0]-date {
        display none
      }
    }

    &-img {
      ratio(413, 478)
      height 100%
    }

    &-info {
      absolute left right top bottom
      z-index 1
      display flex
      flex-direction column
      justify-content space-between
      align-items flex-start
      grid-gap 4px
      padding 30px
      +below(1150px) {
        padding 20px
      }
    }

    &-date {
      font-weight: 400;
      font-size: 0.875em
      line-height: 160%;
      padding 5px 20px
      background: var(--main-color-75)
      border-radius: 5px;
      +below(990px) {
        padding 5px 15px
        font-size: 0.75em
      }
    }

    &-bottom {
      margin-top auto
      display flex
      flex-direction column
      gap 10px
    }

    &-title {
      font-family var(--font_regular)
      font-style: normal;
      font-weight: 700;
      font-size: 2.125em
      line-height: 110%
      margin 0
      text-align left
      text-transform none
      word-break break-word
      maxlines(4)
      +below(990px) {
        font-size: 1.75em
      }
      +below(768px) {
        font-size 1.5em
      }
    }

    &-subtitle {
      display flex
      font-size: 1.125em
      line-height: 160%;
      +below(990px) {
        font-size: 1em
      }
    }
  }
}
</style>
